import { HsaEndStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { FrontendStepType, PartialWithRequiredType } from "..";

export const hsaEndStepType: FrontendStepType<
  PartialWithRequiredType<HsaEndStep>
> = {
  type: "standard",
  valid: (_) => true,
  selectable: (_) => false, // End nodes are not selectable
  inspectorFactory: (_) => ({ sections: [] }),
};
